import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _isLoading = false;
  private _spinnersStack: string[] = [];

  showLoader(): void {
    setTimeout(() => {
      this._spinnersStack.push('');
      this._isLoading = Boolean(this._spinnersStack.length);
    }, 1);
  }

  hideLoader(): void {
    setTimeout(() => {
      if (this._spinnersStack.length) {
        this._spinnersStack.pop();
      }
      if (!this._spinnersStack.length) {
        this._isLoading = false;
      }
    }, 1);
  }

  get isLoading(): boolean {
    return this._isLoading;
  }
}
